
import { defineComponent, computed, onMounted, ref } from "vue";
export default defineComponent({
  name: "SvgIcon",
  props: {
    size: {
      type: Number,
      default: 16,
    },
    name: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "#fff",
    },
    hoverColor: {
      type: String,
      default: "#5754e6",
    },
  },
  setup(props) {
    const svgStyle = computed(() => {
      return {
        "--color": props.color,
        "--hoverColor": props.hoverColor,
        width: `${props.size}px`,
        height: `${props.size}px`,
      };
    });
    // onMounted(() => {});
    return { svgStyle };
  },
});
